export default "__VITE_ASSET__BVBI3n8M__"